import { useEffect, useState } from "react"

import { Search2Icon } from "@chakra-ui/icons"
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Center,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Text,
  useMediaQuery,
  VStack,
} from "@chakra-ui/react"
import { Link, Location, useLocation } from "react-router-dom"

import CheckInsIcon from "components/Icons/sidebarIcons/CheckInsIcon"
import HostPayoutDashboardIcon from "components/Icons/sidebarIcons/HostPayoutDashboardIcon"
import ManageRoleIcon from "components/Icons/sidebarIcons/ManageRoleIcon"
import ManageTokenIcon from "components/Icons/sidebarIcons/ManageTokenIcon"
import PhoneCommunicationIcon from "components/Icons/sidebarIcons/PhoneCommunicationIcon"
import PMSFeeManageIcon from "components/Icons/sidebarIcons/PMSFeeManageIcon"
import ProxyRuleManagementIcon from "components/Icons/sidebarIcons/ProxyRuleManagementIcon"
import { getTitleForUrl } from "components/Title"
import {
  ActionType,
  ModuleType,
  UserRoleType,
  VIEW_ARRAY,
} from "configs/permissions"
import { useAppDispatch, useAppSelector } from "hooks/store/hooks"
import useReviewNotification from "hooks/swr/useReviewNotification"
import { selectUserRole } from "stores/auth/authSlice"
import {
  selectIsSidebarOpen,
  selectRoleDetails,
  toggleSidebar,
} from "stores/ui/uiSlice"
import { Endpoints } from "types"

import Logo from "./Icons/Logo"
import BookingsIcon from "./Icons/sidebarIcons/BookingsIcon"
import CompanyDashboardIcon from "./Icons/sidebarIcons/CompanyDashboardIcon"
import DealsDashboardIcon from "./Icons/sidebarIcons/DealsDashboardIcon"
import EmailCommunicationIcon from "./Icons/sidebarIcons/EmailCommunicationIcon"
import EventsIcon from "./Icons/sidebarIcons/EventsIcon"
import FAQIcon from "./Icons/sidebarIcons/FAQIcon"
import FeeMappingIcon from "./Icons/sidebarIcons/FeeMappingIcon"
import HeroBannerIcon from "./Icons/sidebarIcons/HeroBannerIcon"
import HomeConfigIcon from "./Icons/sidebarIcons/HomeConfigIcon"
import HostContactsIcon from "./Icons/sidebarIcons/HostContactsIcon"
import ManageUsersIcon from "./Icons/sidebarIcons/ManageUsersIcon"
import OfferIcon from "./Icons/sidebarIcons/OfferIcon"
import OnboardingIcon from "./Icons/sidebarIcons/OnboardingIcon"
import PromoCodesIcon from "./Icons/sidebarIcons/PromoCodesIcon"
import PropertyDashboardIcon from "./Icons/sidebarIcons/PropertyDashboardIcon"
import PropertyManageIcon from "./Icons/sidebarIcons/PropertyManageIcon"
import ReportsIcon from "./Icons/sidebarIcons/ReportsIcon"
import ReviewManagementIcon from "./Icons/sidebarIcons/ReviewManagementIcon"
import SendEmailsIcon from "./Icons/sidebarIcons/SendEmailsIcon"
import SmsDashboardIcon from "./Icons/sidebarIcons/SmsDashboardIcon"
import TravelAgentIcon from "./Icons/sidebarIcons/TravelAgentIcon"
import UserDashboardIcon from "./Icons/sidebarIcons/UserDashboardIcon"
import PermittedContentOnly from "./PermittedContentOnly"

type TNavItem = {
  children?: TNavItem[]
  icon: JSX.Element
  isNested: boolean
  link: string
  module: ModuleType
  title: string
}

const navItems: TNavItem[] = [
  {
    title: "Manage Users",
    icon: <ManageUsersIcon />,
    link: Endpoints.manageUsers,
    module: "ManageUsers",
    isNested: false,
  },

  {
    title: "Property Dashboard",
    icon: <PropertyDashboardIcon />,
    link: Endpoints.propertyDashboard,
    module: "PropertyDashboard",
    isNested: false,
  },
  {
    title: "User Dashboard",
    icon: <UserDashboardIcon />,
    link: Endpoints.userDashboard,
    module: "UserDashboard",
    isNested: false,
  },
  {
    title: "Email Communications",
    icon: <EmailCommunicationIcon />,
    link: Endpoints.emailCommunication,
    module: "EmailCommunication",
    isNested: false,
  },
  {
    title: "Phone Proxy",
    icon: <PhoneCommunicationIcon />,
    link: Endpoints.phoneCommunication,
    module: "EmailCommunication",
    isNested: false,
  },
  {
    title: "Booking Dashboard v3",
    icon: <BookingsIcon />,
    link: Endpoints.bookingDashboardV3,
    module: "BookingDashboard",
    isNested: false,
  },
  {
    title: "Check-ins",
    icon: <CheckInsIcon />,
    link: Endpoints.checkIns,
    module: "BookingDashboard",
    isNested: false,
  },
  // {
  //   title: "Bcom Booking Dashboard",
  //   icon: <BookingsIcon />,
  //   link: Endpoints.bcomBookingDashboard,
  //   module: "BookingDashboard",
  //   isNested: false,
  // },
  {
    title: "Extension Offer Manage",
    icon: <OfferIcon />,
    link: Endpoints.extensionOfferManage,
    module: "BookingDashboard",
    isNested: false,
  },
  {
    title: "HCF Charge Dashboard",
    icon: <BookingsIcon />,
    link: Endpoints.hcfChargeDashboard,
    module: "BookingDashboard",
    isNested: false,
  },
  {
    title: "Company Dashboard",
    icon: <CompanyDashboardIcon />,
    link: Endpoints.companyDashboard,
    module: "CompanyDashboard",
    isNested: false,
  },
  {
    title: "Deals Spotlight",
    icon: <DealsDashboardIcon />,
    link: Endpoints.dealsDashboard,
    module: "DealsDashboard",
    isNested: false,
  },
  {
    title: "Host Contact",
    icon: <HostContactsIcon />,
    link: Endpoints.hostContactInfo,
    module: "BookingDashboard",
    isNested: false,
  },
  // {
  //   title: "Whimstay Discount",
  //   icon: <CompanyDashboardIcon />,
  //   link: "",
  //   module: "WhimstayDiscount",
  //   isNested: false,
  //   children: [
  //     {
  //       title: "Company Discount",
  //       icon: <HeroBannerIcon />,
  //       link: Endpoints.manageCompanyDiscount,
  //       module: "WhimstayDiscount",
  //       isNested: true,
  //     },
  //     {
  //       title: "Property Discount",
  //       icon: <PropertyManageIcon />,
  //       link: Endpoints.managePropertyDiscount,
  //       module: "WhimstayDiscount",
  //       isNested: true,
  //     },
  //   ],
  // },
  {
    title: "Host Payout Dashboard",
    icon: <HostPayoutDashboardIcon />,
    link: Endpoints.hostPayoutDashboard,
    module: "HostPayoutDashboard",
    isNested: false,
  },
  {
    title: "CJ Commissions",
    icon: <ReportsIcon />,
    link: Endpoints.cjCommissionDashboard,
    module: "CjCommissionDashboard",
    isNested: false,
  },
  {
    title: "FAQ",
    icon: <FAQIcon />,
    link: Endpoints.faq,
    module: "FAQ",
    isNested: false,
  },
  {
    title: "Reports",
    icon: <ReportsIcon />,
    link: Endpoints.reports,
    module: "Reports",
    isNested: false,
  },
  {
    title: "Proxy Rules",
    icon: <ProxyRuleManagementIcon />,
    link: Endpoints.proxyRules,
    module: "EmailCommunication",
    isNested: false,
  },
  {
    title: "Promo Codes",
    icon: <PromoCodesIcon />,
    link: "",
    module: "PromoCodeDashboard",
    isNested: false,
    children: [
      {
        title: "Manage Promo Codes",
        icon: <PromoCodesIcon />,
        link: Endpoints.managePromoCodes,
        module: "PromoCodeDashboard",
        isNested: true,
      },
      {
        title: "Redeemed Promo Codes",
        icon: <PromoCodesIcon />,
        link: Endpoints.redeemPromoCodes,
        module: "PromoCodeDashboard",
        isNested: true,
      },
    ],
  },
  {
    title: "System Email Log",
    icon: <EmailCommunicationIcon />,
    link: Endpoints.systemEmailLog,
    module: "EmailCommunication",
    isNested: false,
  },
  {
    title: "SMS Dashboard",
    icon: <SmsDashboardIcon />,
    link: Endpoints.smsDashboard,
    module: "EmailCommunication",
    isNested: false,
  },
  {
    title: "Manage Tokens",
    icon: <ManageTokenIcon />,
    link: Endpoints.manageTokens,
    module: "ManageTokens",
    isNested: false,
  },
  {
    title: "PMS Fees Manage",
    icon: <PMSFeeManageIcon />,
    link: Endpoints.pmsFeesManage,
    module: "PMSFeesManage",
    isNested: false,
  },
  {
    title: "Onboarding",
    icon: <OnboardingIcon />,
    link: Endpoints.onboarding,
    module: "OnboardingDashboard",
    isNested: false,
  },
  {
    title: "Events",
    icon: <EventsIcon />,
    link: Endpoints.events,
    module: "Events",
    isNested: false,
  },
  {
    title: "Send Emails",
    icon: <SendEmailsIcon />,
    link: Endpoints.sendEmails,
    module: "SendEmails",
    isNested: false,
  },
  {
    title: "Review Management",
    icon: <ReviewManagementIcon />,
    link: Endpoints.reviewManagement,
    module: "ReviewManagement",
    isNested: false,
  },
  {
    title: "Fee Mapping",
    icon: <FeeMappingIcon />,
    link: Endpoints.feeMapping,
    module: "FeeMapping",
    isNested: false,
  },
  {
    title: "Power Search",
    icon: <Search2Icon fontSize={24} color='#999A9A' />,
    link: Endpoints.powerSearch,
    module: "BookingDashboard",
    isNested: false,
  },
  {
    title: "Home Config.",
    icon: <HomeConfigIcon />,
    link: "",
    module: "HeroConfiguration",
    isNested: false,
    children: [
      {
        title: "Hero Banner",
        icon: <HeroBannerIcon />,
        link: Endpoints.heroBanner,
        module: "HeroConfiguration",
        isNested: true,
      },
      {
        title: "Featured Property",
        icon: <PropertyManageIcon />,
        link: Endpoints.propertyManagement,
        module: "HeroConfiguration",
        isNested: true,
      },
      {
        title: "New to Whimstay",
        icon: <PropertyManageIcon />,
        link: Endpoints.newToWhimstay,
        module: "HeroConfiguration",
        isNested: true,
      },
    ],
  },
  {
    title: "Travel Agents",
    icon: <TravelAgentIcon />,
    link: "",
    module: "TravelAgentDashboard",
    isNested: false,
    children: [
      {
        title: "Agency Management",
        icon: <TravelAgentIcon />,
        link: Endpoints.travelAgentDashboard,
        module: "TravelAgentDashboard",
        isNested: true,
      },
      {
        title: "Agent Management",
        icon: <TravelAgentIcon />,
        link: Endpoints.agentManagement,
        module: "TravelAgentDashboard",
        isNested: true,
      },
      {
        title: "Commission Management",
        icon: <TravelAgentIcon />,
        link: Endpoints.commissionDashboard,
        module: "CommissionDashboard",
        isNested: true,
      },
      {
        title: "Agency Payout Accounts",
        icon: <TravelAgentIcon />,
        link: Endpoints.agentPayoutDashboard,
        module: "TravelAgentDashboard",
        isNested: true,
      },
    ],
  },
]

const NavItem = ({
  item,
  isOpen,
  location,
  isCloseToggle,
  roleData,
}: {
  isOpen: boolean
  isCloseToggle?: boolean
  item: TNavItem
  location: Location
  roleData: {
    role: UserRoleType
    rule: { module: ModuleType; action: ActionType[] }[]
  }[]
}) => {
  const dispatch = useAppDispatch()
  const handleToggle = () => {
    if (isCloseToggle) {
      dispatch(toggleSidebar())
    }
  }

  const getUrl = location.pathname.split("/")
  const newUrl = getUrl[1] + "/" + getUrl[2]
  const isActiveDetails = (url: string, itemTitle: string): boolean => {
    const title = getTitleForUrl(url)
    return title === itemTitle
  }
  const activeDetails = isActiveDetails(newUrl, item.title)
  const { data: reviewStatus } = useReviewNotification()
  return item.children ? (
    <AccordionItem border={"none"}>
      <AccordionButton
        as={Button}
        variant='navItem'
        size='lg'
        isActive={item.link === location.pathname}
        leftIcon={item.icon}
        pl={!isOpen ? "30px" : "12px"}
        transition={"all 0.2s ease"}
        mb={3}
      >
        <Text
          display={isOpen ? "block" : "none"}
          variant='navColor'
          size='sm'
          fontWeight='600'
        >
          {item.title}
        </Text>
        <AccordionIcon ml='auto' display={isOpen ? "block" : "none"} />
      </AccordionButton>
      <AccordionPanel p={0} onClick={handleToggle}>
        {isOpen &&
          item.children?.map((nestedItem) => (
            <PermittedContentOnly key={nestedItem.title} module={item.module}>
              <NavItem
                isOpen={isOpen}
                item={nestedItem}
                location={location}
                key={item.title}
                roleData={roleData}
              />
            </PermittedContentOnly>
          ))}
      </AccordionPanel>
    </AccordionItem>
  ) : (
    <Button
      as={Link}
      to={item.link}
      variant='navItem'
      size='lg'
      isActive={item.link === location.pathname || activeDetails}
      leftIcon={
        <Box position='relative'>
          {item.icon}
          {/* Show red dot when sidebar is closed and reviewStatus is pending */}
          {!isOpen &&
            item.title === "Review Management" &&
            reviewStatus?.isStatusPending && (
              <Box
                position='absolute'
                top='-2px'
                right='-8px'
                bg='red'
                borderRadius='100%'
                w={2.5}
                h={2.5}
              />
            )}
        </Box>
      }
      transition={"all 0.2s ease"}
      pl={item.isNested ? "24px" : !isOpen ? "30px" : "12px"}
      onClick={handleToggle}
      mb={3}
    >
      <Text
        display={
          item.title === "Review Management" && isOpen
            ? "flex"
            : isOpen
            ? "block"
            : "none"
        }
        variant='navColor'
        size='sm'
        fontWeight='600'
      >
        {item.title}
        {/* Show red dot next to text when sidebar is open in Review Management */}
        {item.title === "Review Management" &&
          reviewStatus?.isStatusPending &&
          isOpen && (
            <Text as='span' bg='red' borderRadius='100%' w={2.5} h={2.5} />
          )}
      </Text>
    </Button>
  )
}

const SideDrawerContent = (props: {
  isCloseToggle?: boolean
  roleData: {
    role: UserRoleType
    rule: { module: ModuleType; action: ActionType[] }[]
  }[]
}) => {
  const { isCloseToggle, roleData } = props
  const userRole = useAppSelector(selectUserRole)
  const location = useLocation()
  const isOpen = useAppSelector(selectIsSidebarOpen)
  // State to control which accordion are open
  const [accordionIndex, setAccordionIndex] = useState<number[]>([])

  // Flag to ensure initialization runs only once
  const [initialized, setInitialized] = useState(false)

  if (userRole === "DEVELOPER") {
    const editColumns: TNavItem = {
      title: "Manage Role",
      icon: <ManageRoleIcon />,
      link: Endpoints.manageRole,
      module: "ManageRole",
      isNested: false,
    }
    navItems.unshift(editColumns)

    const editColumnItem: TNavItem = {
      title: "Regional Landing",
      icon: <HomeConfigIcon />,
      link: Endpoints.regionalLanding,
      module: "HeroConfiguration",
      isNested: false,
    }
    navItems.unshift(editColumnItem)
  }

  const set = new Set()
  const column =
    navItems &&
    navItems.filter((item) => {
      const isDuplicate = set.has(item.title)
      set.add(item.title)
      return !isDuplicate
    })

  const filteredData = roleData.filter((item) => item.role === userRole)

  const newItem: any[] = []
  VIEW_ARRAY.map((item) => {
    return filteredData.map((abcObj) => {
      abcObj.rule.map((it) => {
        if (item.module === it.module) {
          if (it.action.includes(item.action as ActionType)) {
            newItem.push(it)
            return it
          }
        }
      })
    })
  })

  const finalNavItem: TNavItem[] = []
  newItem.map((item: { module: string }) => {
    column.map((it) => {
      if (item.module === it.module) {
        finalNavItem.push(it)
        return it
      }
    })
  })
  useEffect(() => {
    if (finalNavItem && finalNavItem[0]) {
      localStorage.setItem("defaultLink", finalNavItem[0].link)
    }
  }, [finalNavItem])

  useEffect(() => {
    // Don't re-run if already initialized
    if (initialized) return

    // Stop if nav items are not ready yet
    if (!finalNavItem || finalNavItem?.length === 0) return

    // Find the parent accordion whose child matches the current route
    const parentIdx = finalNavItem?.findIndex((item) => {
      if (!item.children) return false
      return item.children.some((child) => child.link === location.pathname)
    })

    if (parentIdx !== -1) {
      // Get a filtered list of only parents that contain children
      const parentsWithChildren = finalNavItem?.filter((item) => item.children)

      // Find the group index - the position of this parent among all parents with children
      // Example: first parent = 0, second parent = 1, etc.
      const groupIndex = parentsWithChildren.findIndex(
        (item) => finalNavItem?.indexOf(item) === parentIdx,
      )

      // parentIdx - index in finalNavItem (e.g., 12, 21)
      // groupIndex - iindex among only parents with children (e.g., 0, 1, 2…)
      setAccordionIndex([parentIdx, groupIndex])
    }

    // Set initialization complete so it doesn't run again
    setInitialized(true)
  }, [finalNavItem, location.pathname, initialized])

  return (
    <VStack spacing={0}>
      <Center w='full' m={"15px 10px 35px"}>
        <Logo w={isOpen ? "50%" : "75%"} />
      </Center>
      <Accordion
        allowToggle
        p='15px 10px 10px 10px'
        index={accordionIndex}
        onChange={(val) => {
          const newIndex = Array.isArray(val) ? val : [val]
          setAccordionIndex(newIndex)
        }}
      >
        {userRole &&
          finalNavItem.map((item) => (
            <PermittedContentOnly key={item.title} module={item.module}>
              <NavItem
                key={item.title}
                item={item}
                isOpen={isOpen}
                location={location}
                isCloseToggle={isCloseToggle}
                roleData={roleData}
              />
            </PermittedContentOnly>
          ))}
      </Accordion>
    </VStack>
  )
}

const SideDrawer = () => {
  const isOpen = useAppSelector(selectIsSidebarOpen)
  const dispatch = useAppDispatch()
  const handleToggle = () => {
    dispatch(toggleSidebar())
  }
  const roleData = useAppSelector(selectRoleDetails)
  const [isDesktop] = useMediaQuery("(min-width: 768px)")

  return (
    <>
      {isDesktop ? (
        <Box
          position={"sticky"}
          top='0'
          left={0}
          zIndex={1}
          w={{ base: "0px", md: isOpen ? "300px" : "90px" }}
          minW={{ base: "0px", md: isOpen ? "300px" : "90px" }}
          maxW='300px'
          h='100vh'
          bg='offWhite'
          borderRight={"1px solid #EEE"}
          overflowY={"auto"}
          transition={"all 0.2s ease-in"}
          className='hideScrollbar'
        >
          <SideDrawerContent roleData={roleData} />
        </Box>
      ) : (
        <Drawer isOpen={isOpen} placement='left' onClose={handleToggle}>
          <DrawerOverlay />
          <DrawerContent p='0' maxW={"300px"}>
            <DrawerCloseButton />
            <DrawerBody p='0' className='hideScrollbar' bg='offWhite'>
              <SideDrawerContent isCloseToggle={true} roleData={roleData} />
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      )}
    </>
  )
}

export default SideDrawer
